import DriverShelters from "../../services/api/DriverShelters";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import ErrorMsgs from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import DriverSheltersApi from "../../services/api/DriverShelters";

const handleError = (err) => {
  console.log("[handleError] Error in DriverShelters actions", err);
};

export const setDriverSheltersList = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_SHELTERS_LIST,
    payload,
  };
};

export const setActiveDriverShelter = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_DRIVER_SHELTER,
    payload,
  };
};

export const getDriverSheltersList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let body = {
        page_request: pageRequest,
        filters: filters,
      };

      dispatch(setLoader(true));
      let response = await DriverSheltersApi.getDriverSheltersList(body);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setDriverSheltersList(response));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getDriverShelter = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverSheltersApi.getDriverShelter(id);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActiveDriverShelter(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateDriverShelter =
  (shelter_id, payload) => async (dispatch) => {
    try {
      let data = {
        name: "",
        address: "",
        latitude: "",
        longitude: "",
        is_active: "",
        is_rest_point: "",
        open_timings: "",
        amenities: [],
      };
      payload.latitude = Number(payload.latitude);
      payload.longitude = Number(payload.longitude);
      let bodyData = { id: Number(shelter_id) };
      Object.keys(data).map((key) => {
        bodyData[key] = payload[key];
      });
      dispatch(setLoader(true));
      let response = await DriverSheltersApi.updateShelter(bodyData);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setDriverSheltersList(response));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const createDriverShelter = (shelterData) => async (dispatch) => {
  try {
    let data = {
      name: "",
      address: "",
      latitude: "",
      longitude: "",
      is_active: "",
      is_rest_point: "",
      open_timings: "",
      amenities: [],
    };
    shelterData.latitude = Number(shelterData.latitude);
    shelterData.longitude = Number(shelterData.longitude);
    let bodyData = {};
    Object.keys(data).map((key) => {
      bodyData[key] = shelterData[key];
    });
    dispatch(setLoader(true));
    let response = await DriverSheltersApi.createShelter(bodyData);
    dispatch(setLoader(false));
    if (response) {
      let pageRequest = {
        page: 1,
        page_size: 10,
      };
      dispatch(getDriverSheltersList({}, pageRequest));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
